import React, { useContext } from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";

import { useInput } from "../../../hooks/input-hook";
import SiteMetaContext from "../../../contexts/SiteMetaContext";
import {
  theme5Vars,
  templateVariableValue,
} from "../../../helpers/templateVariables";
import { translateStatic } from "../../../helpers/translationHelper";
import * as theme5Styles from "../scss/theme5.module.scss";

const Banner = () => {
  // eslint-disable-next-line no-unused-vars
  const { value: keyword, bind: bindKeyword, reset: resetKeyword } = useInput(
    ""
  );

  const siteData = useContext(SiteMetaContext);

  const {
    remarso: {
      domainByURL: {
        website: {
          templateConfiguration,
          template: { templateVariables },
          setting: display_settings,
        },
      },
    },
    currentLocaleKey: locale,
    defaultLocaleKey: defaultLocale,
  } = siteData;

  const handleSubmit = (evt) => {
    evt.preventDefault();
    navigate(`/${locale}/properties?search=${keyword}`);
  };

  const { display_search_bar } = display_settings;

  const homeTitle = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-main-title",
    locale,
    defaultLocale
  );
  const homeText = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-main-text",
    locale,
    defaultLocale
  );
  const backgroundImg = templateVariableValue(
    templateConfiguration,
    templateVariables,
    theme5Vars[0].slug,
    locale,
    defaultLocale
  );

  return (
    <section
      className={theme5Styles.banner}
      style={{
        backgroundImage: `url(${backgroundImg || theme5Vars[0].image})`,
      }}
      loading="lazy"
    >
      <div className={theme5Styles.wrapper}>
        <div className={theme5Styles.bannerTextC}>
          <div className={theme5Styles.bannerText}>
            <h2 className={theme5Styles.bannerTl}>{homeTitle}</h2>
            <p>{homeText}</p>
            <form onSubmit={handleSubmit}>
              {(() => {
                if (display_search_bar) {
                  let placeholder = translateStatic(
                    "city",
                    locale,
                    defaultLocale
                  );
                  placeholder +=
                    ", " + translateStatic("address", locale, defaultLocale);
                  placeholder +=
                    ", " + translateStatic("zip_code", locale, defaultLocale);

                  return (
                    <div className={theme5Styles.banSearchBox}>
                      <input
                        type="text"
                        className={theme5Styles.searchField}
                        placeholder={placeholder}
                        {...bindKeyword}
                      />
                      <button
                        className={`${theme5Styles.searchBtn}`}
                      >
                        {translateStatic("search", locale, defaultLocale)}
                      </button>
                    </div>
                  );
                }
              })()}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

Banner.propTypes = {
  backgroundImg: PropTypes.string,
  locale: PropTypes.string,
};

export default Banner;
